import React from 'react';
import './Order.css'; // Import combined CSS

export const Modal = ({ isOpen, onClose, onSaleOrder, onSaleReturn }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Select an Option</h2>
        <button className="modal-button" onClick={onSaleOrder}>Sale Order</button>
        <button className="modal-button" onClick={onSaleReturn}>Sale Returns</button>
        <button className="modal-close" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default Modal;
